import React from 'react';
import Icon from '@amzn/awsui-components-core/icon';
import styles from 'src/components/star-grid/components/styles/ReportFilterBar.module.scss';
/**
 * A click ANYWHERE on the chip opens its control, as the deck's chips do.
 *
 * The label, padding and chevron are plain elements; only the trigger inside acts. For most chips a
 * stretched pseudo-element covers that gap, but a control that wraps its trigger in a positioned
 * container (the Version picker's Dropdown) confines it, so clicking the chip's arrow or label opened
 * nothing. Clicks that already landed on the trigger, an input, or the open panel are left alone.
 */
const openChipControl = (event: React.MouseEvent<HTMLDivElement>): void => {
  const target = event.target as HTMLElement;
  if (target.closest('button, input, [role="dialog"], [role="listbox"]')) return;
  event.currentTarget.querySelector<HTMLButtonElement>('button[aria-haspopup], button')?.click();
};

interface Props {
  readonly label: string;
  readonly controlId: string;
  readonly value?: string;
  /**
   * Hover text, when the full selection reads longer than the value shown.
   *
   * A hierarchy filter summarises several members as `First +2`, so the chip's own title has to carry
   * the whole list; defaults to `value`, which is what every other caller wants.
   */
  readonly title?: string;
  readonly dropdown?: boolean;
  readonly children: React.ReactNode;
}
export const ReportFilterField: React.FC<Props> = ({ label, controlId, value, title, dropdown = true, children }) => (
  <div className={styles.field} data-report-filter={controlId} title={title ?? value} onClick={openChipControl}>
    <label className={styles.label} htmlFor={controlId}>
      {label}
    </label>
    <span className={styles.valueWidth} aria-hidden="true">
      {value}
    </span>
    <div className={styles.control}>
      {children}
      {dropdown && (
        <span className={styles.chevron} aria-hidden="true">
          <Icon name="angle-down" size="small" />
        </span>
      )}
    </div>
  </div>
);
